import { getCookie, removeCookie } from "@common/auth";
import { useRouter } from "next/router";
import { useMemo, useEffect } from "react";
import { logoutConfirm } from "@common/confirm";
import {
  closeConfirmModal,
  modifyConfirmModal,
  openConfirmModal,
} from "@redux/action/confirm";
import { initBaskets } from "@redux/action/baskets";
import { initUserInfo } from "@redux/action/userInfo";
import { useDispatch } from "react-redux";

export const useAuthHandler = ({ userInfo, setIsUser, setBtnText }) => {
  const router = useRouter();
  const dispatch = useDispatch();

  const userName = useMemo(() => {
    if (userInfo?.Member?.name) {
      return userInfo?.Member?.name + "님";
    } else {
      return null;
    }
  }, [userInfo]);

  const userCompanyName = useMemo(() => {
    if (userInfo?.Company?.Data?.code) {
      return userInfo?.Company?.Data?.name;
    } else {
      return "";
    }
  }, [userInfo]);

  // 로그아웃 핸들러
  const logoutConfirmHandler = () => {
    removeCookie("token");
    dispatch(initUserInfo());
    if (getCookie("username")) removeCookie("username");

    if (router.asPath === "/") {
      dispatch(initBaskets());
      dispatch(closeConfirmModal());
      router.reload();
    } else {
      dispatch(initBaskets());
      dispatch(closeConfirmModal());
      router.push("/");
    }
  };

  // 토큰 유무에 따른 로그인 및 로그아웃 액션 처리
  const authHandler = () => {
    if (!getCookie("token")) {
      return router.push("/login");
    } else {
      dispatch(modifyConfirmModal(logoutConfirm(logoutConfirmHandler)));
      return dispatch(openConfirmModal());
    }
  };

  // 토큰 유무에 따른 로그인 버튼 레이아웃 분기처리
  const showBtnText = () => {
    if (!getCookie("token")) {
      setIsUser(false);
      return setBtnText("로그인");
    } else if (getCookie("token")) {
      setIsUser(true);
      return setBtnText("로그아웃");
    }
  };

  // 컴포넌트 마운트 시 버튼 텍스트 설정
  useEffect(() => {
    showBtnText();
  }, [userInfo]);

  return {
    userName,
    userCompanyName,
    authHandler,
    logoutConfirmHandler,
    showBtnText,
  };
};
